export default {"src":"/_next/static/media/star-filled.0512dffa.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};